import React from "react";
import { ThreeDot } from "react-loading-indicators";

const Loading = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 0",
      }}
    >
      <ThreeDot
        color="#A30003"
        size="large"
        textColor="#000000"
      />
    </div>
  );
};

export default Loading;
